// Brand + shared constants
export const BRAND = {
  name: 'Dany Trans',
  primary: '#C52429',
  primaryDark: '#A81E23',
  logoUrl: 'https://customer-assets.emergentagent.com/job_1202ce65-e0fb-4c92-9a95-32bdbc66c5ea/artifacts/l7pqo8fl_ryr27z63_Design-sem-nome-28-1.png',
};

export const ROLES = ['Administrador', 'Financeiro', 'RH', 'Operacional', 'Manutenção', 'Estoque', 'Comercial'];

export const BRAZIL_STATES = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

export const VEHICLE_TYPES = ['Ônibus', 'Van', 'Micro-ônibus', 'Caminhão', 'Carro', 'Utilitário'];

// Fase 3 - Situações da Frota
export const VEHICLE_SITUATIONS = [
  'Ativo',
  'Em Operação',
  'Em Manutenção',
  'Reserva',
  'Vendido',
  'Baixado',
  'Sinistrado',
];
export const VEHICLE_STATUSES = VEHICLE_SITUATIONS; // legacy alias

export const CLIENT_TYPES = ['Venda de veículo', 'Turismo', 'Fretamento'];

export const FUEL_TYPES = ['Diesel S10', 'Diesel S500', 'Gasolina', 'Etanol', 'GNV', 'Elétrico', 'Híbrido'];

export const GEARBOX_TYPES = ['Manual', 'Automático', 'Automatizado', 'CVT'];

export const BODY_TYPES = ['Rodoviário', 'Urbano', 'Micro', 'Van', 'Baú', 'Sider', 'Carreta', 'Caçamba', 'Outro'];

export const PHOTO_CATEGORIES = [
  { key: 'frente', label: 'Frente' },
  { key: 'traseira', label: 'Traseira' },
  { key: 'lateral_direita', label: 'Lateral Direita' },
  { key: 'lateral_esquerda', label: 'Lateral Esquerda' },
  { key: 'interior', label: 'Interior' },
  { key: 'motor', label: 'Motor' },
  { key: 'outros', label: 'Outros' },
];

export const LICENSING_TYPES = [
  'Seguro', 'ANTT', 'Metroplan', 'Tacógrafo', 'Secretaria',
];

// Situation → badge tone
export const SITUATION_TONES = {
  'Ativo': 'emerald',
  'Em Operação': 'blue',
  'Em Manutenção': 'amber',
  'Reserva': 'neutral',
  'Vendido': 'purple',
  'Baixado': 'red',
  'Sinistrado': 'red',
};
